import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable, isDevMode } from '@angular/core';
import { Observable, map } from 'rxjs';
import { environment } from 'src/environments/environment';
import { Setting } from '../models/settings/setting';
import { SettingDeleteResult, SettingListResult, SettingResult } from '../models/settings/setting-result';

const httpOptions = {
  headers: new HttpHeaders({
    'Content-Type': 'application/json',
    Accept: 'application/json',
  }),
};

@Injectable({
  providedIn: 'root',
})
export class SettingsService {
  constructor(private http: HttpClient) {}

  listSettings(orgId: string | null): Observable<Setting[]> {
    const url = `${environment.apiBase}/settings?org_id=${orgId}`;
    if (isDevMode()) {
      console.log('[DEV] [SettingsService] loading settings');
    }
    return this.http.get<SettingListResult>(url, httpOptions).pipe(map((res: SettingListResult) => res.settings));
  }

  createSetting(newSetting: Setting): Observable<SettingResult> {
    const url = `${environment.apiBase}/settings`;
    if (isDevMode()) {
      console.log('[DEV] [SettingsService] creating setting', newSetting);
    }
    return this.http.post<SettingResult>(url, newSetting, httpOptions);
  }

  deleteSetting(setting: Setting): Observable<SettingDeleteResult> {
    if (isDevMode()) {
      console.log('[DEV] [SettingsService] deleting setting', setting.id);
    }
    const url = `${environment.apiBase}/settings/${setting.id}`;
    return this.http.delete<SettingDeleteResult>(url, httpOptions);
  }

  updateSetting(updateSetting: Setting): Observable<SettingResult> {
    const url = `${environment.apiBase}/settings/${updateSetting.id}`;
    if (isDevMode()) {
      console.log('[DEV] [SettingsService] updating setting', updateSetting);
    }
    return this.http.put<SettingResult>(url, updateSetting, httpOptions);
  }

  detailSetting(id: string): Observable<Setting> {
    const url = `${environment.apiBase}/settings/${id}`;
    return this.http.get<SettingResult>(url, httpOptions).pipe(map((res: SettingResult) => res.setting));
  }
}
